import { DI } from '@intigral/constant/config/DIContainer';
import { JsonType } from '@intigral/types';
import { container } from '../../../DataDomain';
import { ICmsRepository } from '../../repositories/interfaces/iCmsRepository';
import { ICmsLanguageResponse } from '../../../entity/interface/iCmsLanguage';

export interface IGetLanguageUseCase {
    execute(language: string): Promise<ICmsLanguageResponse['data']>;
}

export class GetLanguageUseCase implements IGetLanguageUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get cmsRepository(): ICmsRepository {
        return container.resolve<ICmsRepository>(DI.REPOSITORIES.ICmsRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(language: string): Promise<ICmsLanguageResponse['data']> {
        const response = await this.cmsRepository.getLanguage(language);
        return response['data'] as JsonType;
    }
}
